
export const TODAY = 'TODAY'
export const YESTERDAY = 'YESTERDAY'
export const TWO_DAYS_AGO = 'TWO_DAYS_AGO'

export const HORIZONTAL_BAR = 'HORIZONTAL_BAR'
export const VERTICAL_BAR = 'VERTICAL_BAR'
export const LINE = 'LINE'

export const CASES = 'Cases'
export const DEATHS = 'Deaths'
export const RECOVERED = 'Recovered'
export const ACTIVE = 'ACTIVE'

export const PRIMARY = 'primary'
export const SECONDARY = 'secondary'
export const SUCCESS = 'success'
export const WARNING = 'warning'
export const DANGER = 'danger'
export const INFO = 'info'
export const DARK = 'dark'
export const LIGHT = 'light'

export const OUTLINE_PRIMARY = 'outline-primary'
export const OUTLINE_SECONDARY = 'outline-secondary'
export const OUTLINE_SUCCESS = 'outline-success'
export const OUTLINE_WARNING = 'outline-warning'
export const OUTLINE_DANGER = 'outline-danger'
export const OUTLINE_INFO = 'outline-info'
export const OUTLINE_DARK = 'outline-dark'
export const OUTLINE_LIGHT = 'outline-light'

export const CASES_DESCEND = 'CASES_DESCEND'
export const CASES_ASCEND = 'CASES_ASCEND'
export const DEATHS_DESCEND = 'DEATHS_DESCEND'
export const DEATHS_ASCEND = 'DEATHS_ASCEND'
export const RECOVERED_DESCEND = 'RECOVERED_DESCEND'
export const RECOVERED_ASCEND = 'RECOVERED_ASCEND'


